import sha256 from 'crypto-js/sha256';
export var getCookie = function (name) {
    if (typeof document === 'undefined') {
        return null;
    }
    var value = "; ".concat(document.cookie);
    var parts = value.split("; ".concat(name, "="));
    if (parts.length === 2) {
        return parts[1].split(';').shift();
    }
    else {
        return null;
    }
};
export var setCookie = function (name, value, days) {
    if (typeof document !== 'undefined') {
        var expires = '';
        var domain = document.location.hostname.includes('spartacodingclub')
            ? '.spartacodingclub.kr'
            : document.location.hostname;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; domain=".concat(domain, "; expires=") + date.toUTCString();
        }
        else {
            expires = "; domain=".concat(domain, "; expires=Thu, 01 Jan 1970 00:00:01 GMT");
        }
        document.cookie = name + '=' + encodeURIComponent(value || '') + expires + '; path=/';
    }
};
var padZero = function (dateUnit) {
    if (dateUnit < 10) {
        return '0' + dateUnit;
    }
    else {
        return dateUnit;
    }
};
export var calculateTimeLeft = function (endTime, padding) {
    if (padding === void 0) { padding = true; }
    var now = new Date();
    if (typeof endTime === 'string')
        endTime = new Date(endTime);
    var timeDelta = +endTime - +now;
    if (timeDelta <= 0) {
        timeDelta = 0;
    }
    var daysLeft = Math.floor(timeDelta / (1000 * 60 * 60 * 24));
    var hoursLeft = Math.floor((timeDelta / (1000 * 60 * 60)) % 24);
    var minutesLeft = Math.floor((timeDelta / (1000 * 60)) % 60);
    var secondsLeft = Math.floor((timeDelta / 1000) % 60);
    return {
        days: daysLeft,
        hours: padding ? padZero(hoursLeft) : hoursLeft,
        minutes: padding ? padZero(minutesLeft) : minutesLeft,
        seconds: padding ? padZero(secondsLeft) : secondsLeft,
    };
};
export var moveArrayElement = function (arr, fromIndex, toIndex) {
    var element = arr.splice(fromIndex, 1)[0];
    arr.splice(toIndex, 0, element);
    return arr;
};
export var moveArrayElementToTop = function (arr, elem) {
    return moveArrayElement(arr, arr.indexOf(elem), 0);
};
export var hashSha256 = function (message) {
    var hash = sha256(message);
    return hash.toString();
};
export var formatDate = function (isoString) {
    var date = new Date(isoString);
    var year = date.getFullYear();
    var month = (date.getMonth() + 1).toString().padStart(2, '0');
    var day = date.getDate().toString().padStart(2, '0');
    return "".concat(year, "\uB144 ").concat(month, "\uC6D4 ").concat(day, "\uC77C");
};
//# sourceMappingURL=index.js.map